import { useEffect, useState } from "react";
import { NAV_LINKS } from "../data/content";

const useClock = () => {
    const [now, setNow] = useState("");
    useEffect(() => {
        const fmt = new Intl.DateTimeFormat("en-GB", {
            timeZone: "Europe/Rome",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
            timeZoneName: "short",
        });
        const tick = () => setNow(fmt.format(new Date()));
        tick();
        const t = setInterval(tick, 1000);
        return () => clearInterval(t);
    }, []);
    return now;
};

export const Nav = () => {
    const time = useClock();

    const go = (e, href) => {
        e.preventDefault();
        const el = document.querySelector(href);
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
        else el.scrollIntoView();
    };

    return (
        <header
            data-testid="main-nav"
            className="fixed top-0 left-0 right-0 z-50 border-b border-[var(--line)] bg-[rgba(10,10,10,0.72)] backdrop-blur-md"
        >
            <div className="flex items-center justify-between px-6 md:px-12 py-4">
                <a
                    href="#top"
                    onClick={(e) => go(e, "body")}
                    data-testid="nav-logo"
                    className="font-display text-sm tracking-tight uppercase"
                >
                    Marco Giavazzi
                    <span className="font-script text-[var(--mute)] text-base ml-2 normal-case">archive</span>
                </a>
                <div className="hidden lg:block font-mono2 text-[10px] tracking-[0.2em] text-[var(--mute)]" data-testid="nav-clock">
                    BERGAMO — {time}
                </div>
                <nav className="flex items-center gap-3 md:gap-5">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={(e) => go(e, l.href)}
                            data-testid={`nav-item-${l.label.toLowerCase()}`}
                            className="font-mono2 text-[9px] md:text-[11px] tracking-[0.12em] whitespace-nowrap text-[var(--bone)] hover:text-[var(--red)] transition-colors duration-300"
                        >
                            [ {l.label} ]
                        </a>
                    ))}
                </nav>
            </div>
        </header>
    );
};
